import { render, staticRenderFns } from "./compliance-bundle-information.vue?vue&type=template&id=0a5874d0"
import script from "./compliance-bundle-information.vue?vue&type=script&lang=js"
export * from "./compliance-bundle-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports